import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@docorga-v1/docorga-angular';
import { Docorga } from '@docorga-v1/docorga-common';

@Injectable()
export class StructureMemberResource {
  private baseUri = '/prl/structureMembers';

  constructor(private ApiService: ApiService) {}

  // GET
  getStructureMember(): Observable<Docorga.interfaces.structureMember.IStructureMemberPublicJson> {
    return this.ApiService.get(`${this.baseUri}/me`);
  }


  createStructure(structureMember: Docorga.interfaces.structure.IStructureCreateJson['structureMember']) {
    const structureToCreate = { structureMember };
    return this.ApiService.post(`${this.baseUri}/structures`, structureToCreate);
  }

  // PUT
  updateSettings(params: {
    structureMemberId: Docorga.interfaces.naturalTypes.NStructureMemberObjectId;
    structureMemberSettings: Docorga.interfaces.structureMember.IStructureMemberPublicJson;
  }): Observable<Docorga.interfaces.structureMember.IStructureMemberPublicJson | string> {
    return this.ApiService.put(`${this.baseUri}/${params.structureMemberId}/settings`, params);
  }
}
